import React, { FunctionComponent, Fragment, useContext } from 'react';
import { FormContext, SurPlusResultData } from '../../../store/surplus/SurPlusContext';
import { numberToCurrency, scrollToTop, useStepper } from '../../../utils';
import { Button } from '../../shared/Button';
import { Text } from '../../shared/Text';
import { ArrowLongDown } from '../../../icons/components';
import { formItems } from '../SurPlusStepper/formItems';

export const SurPlusResult: FunctionComponent<{ data: SurPlusResultData | null }> = ({data}) => {
	const {setCurrentStep, setStepActive} = useStepper();
	const { updateData, form, consumer } = useContext(FormContext);

	const setFirstStepActive = () => {
		updateData(null)
		setCurrentStep(2);
		setStepActive(2, true);
	};

	const getSurplusInformationLink = () => {
		let link = `https://www.hypotheker.nl/campagnes/profiteer-van-de-overwaarde-op-je-woning/`
		if (consumer) {
			link += `?${consumer.path?.links.surplusInformation}`
		}
		return link;
	}

	const getCanIAffordThisHouseLink= () => {
		let link = `https://www.hypotheker.nl/zelf-berekenen/kan-ik-dit-huis-betalen/calculator/?Heeft_Woning=true&Overslaan_Hypotheek=false&Huis_Prijs=${data?.salesPrice}&Verkoop_Kosten=${data?.salesCosts}&Hoogte_Hypotheek=${data?.mortgage}`
		if (consumer) {
			link += `&${consumer.path?.links.canIAffordThisHouse}`
		}
		return link
	}

	const getAppointmentLink = () => {
		const {  pathname } = window.location;
		let link = 'https://www.hypotheker.nl/afspraak-maken-hypotheekadviseur';
		if (pathname.includes('overwaarde-berekenen')) {
			link = 'https://www.hypotheker.nl/afspraak-maken-hypotheekadviseur-overwaarde/';
		}
		return link;
	}

	return (
		<Fragment>
			<div className="c-surplus-result">
				<button className="stepper__back-button" onClick={setFirstStepActive}>
                    <span className="stepper__back-button-icon">
                        <ArrowLongDown width={12}/>
                    </span>
					Vorige stap
				</button>
				<div className="stepper__step stepper__step--is-active stepper__step--is-touched">
					<div className="stepper__step-content">
						<div className="c-surplus-result__wrapper">
							<span className="stepper__step-title">Overwaarde</span>
							<Text as="h2">{numberToCurrency(data?.surplus, true)}</Text>
							<span className="stepper__step-title">Geschatte waarde van je huidige woning</span>
							<Text as="h3">{numberToCurrency(data?.salesPrice, true)}</Text>
						</div>
					</div>
				</div>

				<div className="c-surplus-result__cta">
					{form[formItems.step3.reasonForCalculation.name] === 'selling' ? (
						<Text as="p">
							De overwaarde op je woning kan je o.a. gebruiken om over te bieden op een nieuwe woning of juist je hypotheeksom te verlagen omdat je (een deel van) je overwaarde gebruikt om de koopsom te betalen. In onze berekening kan je berekenen of de woning die je op het oog hebt betaalbaar is als je je overwaarde inzet.					</Text>
					) : (
						<Text as="p">
							Met je overwaarde kun je o.a. je hypotheek verhogen en hiermee ruimte creëren om je woning te verbouwen en/of te verduurzamen. Onze hypotheekadviseurs vertellen je hier graag meer over.
						</Text>
					)}

					{consumer.status ? (
					<Button onClick={scrollToTop} label="Ik wil een intake" link="/afspraak" variant="tertiary" />
						) : (
						<Button variant="tertiary" label="Afspraak maken"
						url={getAppointmentLink()}></Button>
						)}



					{form[formItems.step3.reasonForCalculation.name] === 'selling' ? (
					<Button variant="link" target={(consumer.status) ? '_blank' : '_self'} label="Reken verder" extraClasses={'c-surplus-result__cta__link'}
                  url={getCanIAffordThisHouseLink()}/>
					): null }

					{consumer.status &&
          <Button variant="link" target='_blank' label="Wat kan ik met mijn overwaarde?" extraClasses={'c-surplus-result__cta__link'}
                  url={getSurplusInformationLink()}/>
					}

				</div>

			</div>
		</Fragment>
	);
};
